<template>

  <div class="colorFondo">
    
    <v-container fluid class="white elevation-3 margen">
      <h1>Almacenes</h1>
    </v-container>


    <v-row class="d-flex justify-space-around mt-3">
      <Productos v-for="almacen in almacenes" :key="almacen.ALMACEN_ID" :infoAlmacen="almacen"/>
    </v-row>
  </div>

</template>

<script>
import Productos from './Productos.vue';
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {Productos},
  data() {
    return {
      almacenes: [],
    };
  },

  computed: {
    ...mapGetters(["getURLAPI"]),
  },

  methods: {
    
  },

  async created() {
    document.title = "Almacenes | Bombas y Suministros del Norte"

    // this.almacenes = (await axios.get(`${this.getURLAPI}/storage/all`)).data; // ADAL
    this.almacenes = (await axios.get(`${this.getURLAPI}/Almacen/all`)).data; // LOCAL

    console.log(this.almacenes);

  },
};

</script>

<style>

</style>
